import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { DataOwnerConfigDTO } from '@retail/member-config/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface FetchProps extends QueryOptions {
  brandId: string;
}

export function useFetchMemberConfig({ brandId, ...queryOptions }: FetchProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<DataOwnerConfigDTO[]>({
    method: 'GET',
    queryKey: ['member-config'],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortmentConfig.brands.brand.getFullLinkPath({ brandId }),
    }),
    ...queryOptions,
  });
}
